<template>
    <transition name="modal">
            <div class="modal-mask" :dataPopup="dataPopup">
                <div class="container">
                    <center>
                        <h2 class="popPupText">{{this.textInfo}}</h2><br>
                        <b-button id="send" v-on:click="mouseOver($event)">Enviar mensajes</b-button>
                        <b-button id="close" v-on:click="mouseOver($event)">Cancelar</b-button>
                    </center>
                </div>
            </div>
    </transition>    
</template>
<script>
import { serverBus } from '../main'
var json;
export default {
    data(){
        return{
            textInfo:""
        }
    },
    created(){
        
    },
    mounted(){
        
        json = this.dataPopup[0]
        json["canal"]=this.dataPopup[1]
        json["pacientes"]=this.dataPopup[2]
        console.log("datapopup",json)
        if(this.dataPopup["module"]=="module1" || this.dataPopup["module"]=="module2"){
              var title2 = ""
              if(this.dataPopup["status"] =="contactados"){
                title2 = "Con registro de actividad"
              }else if(this.dataPopup["status"]=="no_contactados"){
                title2 = "Sin registro de actividad"
              }
            this.textInfo = "Quieres enviar un mensaje a los " + this.dataPopup[3] + " pacientes " + title2 + " de " + this.dataPopup["name"] + "."
        }else{
              var title = ""
              if(this.dataPopup["programa"] =="p_seguimiento"){
                title = "Seguimiento"
              }else if(this.dataPopup["programa"]=="p_rhb"){
                title = "Rehabilitacion pulmonar"
              }
              var title2 = ""
              if(this.dataPopup["status"] =="contactados"){
                title2 = "Con registro de actividad"
              }else if(this.dataPopup["status"]=="no_contactados"){
                title2 = "Sin registro de actividad"
              }
            this.textInfo = "Quieres enviar un mensaje a los " + this.dataPopup[3] + " pacientes " + title2 + " de " + title + "."
        }
        console.log("popup",this.dataPopup)
    },
    props:{
        dataPopup:{}
    },
    methods:{
       mouseOver:function(event){
           
           var buttonID = event.currentTarget.id;
           var action=""
           switch(buttonID){
               case 'send':
                    action = "send"
                    break
               case 'close':
                    action = "close"
                    break
           }
           setTimeout(() => serverBus.$emit('closePopup',[action,json]));
       } 
    }
}
</script>
<style scoped>
.modal-mask {
    color:white;
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    min-height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: flex;
    transition: opacity .3s ease;
    justify-content: center;
    align-items: center
    }
.container {
  margin: 0 auto;
  background-color:#fff;
  border-radius: 15px;
  width: 40%;
  height: 20%;
  padding-top: 2%;
  padding-bottom: 5%;
  padding-left: 5%;
  padding-right: 5%;
}
.popPupText{
    color:black
}
</style>


// WEBPACK FOOTER //
// src/components/PopupBarSelected.vue